import { render, staticRenderFns } from "./SmartButtonView.vue?vue&type=template&id=20ddfb93&scoped=true"
import script from "./SmartButtonView.vue?vue&type=script&lang=js"
export * from "./SmartButtonView.vue?vue&type=script&lang=js"
import style0 from "./SmartButtonView.vue?vue&type=style&index=0&id=20ddfb93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ddfb93",
  null
  
)

export default component.exports